import { render, staticRenderFns } from "./FamilyQuoteCalculator.vue?vue&type=template&id=40620327&scoped=true"
import script from "./FamilyQuoteCalculator.vue?vue&type=script&lang=js"
export * from "./FamilyQuoteCalculator.vue?vue&type=script&lang=js"
import style0 from "./FamilyQuoteCalculator.vue?vue&type=style&index=0&id=40620327&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40620327",
  null
  
)

export default component.exports